"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useState } from "react";
import PinnedWavesScroller from "./pinned-waves/subcomponents/PinnedWavesScroller";
import { useWaveData } from "@/hooks/useWaveData";
import { useRouter } from "next/navigation";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveHomeRoute } from "@/helpers/navigation.helpers";
import { useMyStream } from "@/contexts/wave/MyStreamContext";
import { usePinnedWaveSnapshotSync } from "./pinned-waves/hooks/usePinnedWaveSnapshotSync";
const BrainContentPinnedWaves: React.FC = () => {
  const $ = _c(22);
  const router = useRouter();
  const {
    activeWave,
    directMessages
  } = useMyStream();
  const currentWaveId = activeWave.id;
  let t0;
  if ($[0] !== currentWaveId) {
    t0 = {
      waveId: currentWaveId
    };
    $[0] = currentWaveId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: currentWave
  } = useWaveData(t0);
  const {
    isApp
  } = useDeviceInfo();
  const directMessagesList = directMessages.list;
  let t1;
  if ($[2] !== currentWaveId || $[3] !== directMessagesList) {
    t1 = currentWaveId && directMessagesList.some(wave => wave.id === currentWaveId);
    $[2] = currentWaveId;
    $[3] = directMessagesList;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const currentWaveIsDirectMessage = Boolean(t1);
  const [hoveredWaveId, setHoveredWaveId] = useState(null);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setHoveredWaveId(null);
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const clearHoveredWaveId = t2;
  let t3;
  if ($[6] !== currentWave || $[7] !== currentWaveId || $[8] !== currentWaveIsDirectMessage) {
    t3 = {
      currentWaveId,
      currentWave,
      currentWaveIsDirectMessage
    };
    $[6] = currentWave;
    $[7] = currentWaveId;
    $[8] = currentWaveIsDirectMessage;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const {
    cancelRefresh,
    pinnedWaves,
    removeId
  } = usePinnedWaveSnapshotSync(t3);
  let t4;
  if ($[10] !== cancelRefresh || $[11] !== currentWaveId || $[12] !== directMessagesList || $[13] !== isApp || $[14] !== removeId || $[15] !== router) {
    t4 = waveId => {
      cancelRefresh(waveId);
      if (currentWaveId === waveId) {
        const isDirectMessage = directMessagesList.some(w => w.id === waveId);
        router.replace(getWaveHomeRoute({
          isDirectMessage,
          isApp
        }));
      }
      removeId(waveId);
    };
    $[10] = cancelRefresh;
    $[11] = currentWaveId;
    $[12] = directMessagesList;
    $[13] = isApp;
    $[14] = removeId;
    $[15] = router;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const onRemove = t4;
  if (!pinnedWaves.length) {
    return null;
  }
  let t5;
  if ($[17] !== currentWaveId || $[18] !== hoveredWaveId || $[19] !== onRemove || $[20] !== pinnedWaves) {
    t5 = <PinnedWavesScroller pinnedWaves={pinnedWaves} currentWaveId={currentWaveId} hoveredWaveId={hoveredWaveId} onHoverWave={setHoveredWaveId} onHoverExit={clearHoveredWaveId} onRemove={onRemove} />;
    $[17] = currentWaveId;
    $[18] = hoveredWaveId;
    $[19] = onRemove;
    $[20] = pinnedWaves;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
};
export default BrainContentPinnedWaves;